import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Mail, Phone, Calendar } from 'lucide-react';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!email || !email.includes('@')) {
      setMessage('Please enter a valid email address');
      return;
    }
    setIsSubmitting(true);
    setMessage('');

    // Simple email validation and feedback
    setTimeout(() => {
      setMessage('Thank you for subscribing!');
      setEmail('');
      setIsSubmitting(false);
      setTimeout(() => setMessage(''), 3000);
    }, 500);
  };
  return (
    <footer className="bg-slate-50 pt-16 pb-8 border-t border-slate-200">
      <div className="max-w-content-wide mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div className="col-span-1 md:col-span-1">
            <h3 className="text-xl font-semibold text-slate-900 mb-4 tracking-tight">Kaeliv Technologies</h3>
            <p className="text-slate-600 text-sm leading-relaxed mb-4">
              Crafting Modern Software for Modern Businesses. We turn complex problems into elegant digital solutions.
            </p>
            <p className="text-xs text-slate-500 italic">
              Key to Innovation & Living Technology
            </p>
          </div>

          <div>
            <h4 className="text-base font-semibold text-slate-900 mb-6 tracking-tight">Services</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li><Link to="/services" className="hover:text-primary transition">Web Development</Link></li>
              <li><Link to="/services" className="hover:text-primary transition">Mobile Apps</Link></li>
              <li><Link to="/services" className="hover:text-primary transition">SaaS Platforms</Link></li>
              <li><Link to="/services" className="hover:text-primary transition">Cloud Solutions</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-slate-900 mb-6 tracking-tight">Contact</h4>
            <ul className="space-y-3 text-sm text-slate-600">
              <li className="flex items-center gap-2">
                <Mail size={16} />
                <a
                  href="mailto:info@kaelivtech.com"
                  className="hover:text-primary transition"
                >
                  info@kaelivtech.com
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Phone size={16} />
                <a
                  href="tel:+918487996556"
                  className="hover:text-primary transition"
                >
                  +91 8487996556
                </a>
              </li>
              <li className="flex items-center gap-2">
                <Calendar size={16} />
                <button
                  onClick={() => window.Calendly && window.Calendly.initPopupWidget({ url: 'https://calendly.com/kaelivtech-info' })}
                  className="hover:text-primary transition text-left"
                >
                  Schedule a Meeting
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-base font-semibold text-slate-900 mb-6 tracking-tight">Newsletter</h4>
            <p className="text-sm text-slate-600 mb-4">Subscribe for latest tech insights.</p>
            <form onSubmit={handleSubmit} className="flex flex-col gap-2">
              <input
                type="email"
                placeholder="Your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="px-4 py-2 rounded-md bg-white border border-slate-200 focus:outline-none focus:ring-1 focus:ring-primary text-slate-900"
              />
              <button
                type="submit"
                disabled={isSubmitting}
                className="bg-primary hover:bg-primary/90 disabled:bg-primary/50 disabled:cursor-not-allowed text-white px-4 py-2 rounded-md transition-colors duration-200"
              >
                {isSubmitting ? 'Subscribing...' : 'Subscribe'}
              </button>
              {message && (
                <p className={`text-xs mt-1 ${message.includes('Thank you') ? 'text-green-600' : 'text-red-600'}`}>
                  {message}
                </p>
              )}
            </form>
          </div>
        </div>

        <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-sm text-slate-500">© {new Date().getFullYear()} Kaeliv Technologies. All rights reserved.</p>
          <div className="flex items-center gap-2 mt-4 md:mt-0">
            <a
              href="https://www.linkedin.com/company/111103417/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-400 hover:text-primary transition-colors"
              aria-label="Visit our LinkedIn page"
            >
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;